import { getObservableById, setObservableById } from './helper';

export const rootFolderSubject$ = new Map();

export const getRootFolder$ = (compId: string) =>
  getObservableById(rootFolderSubject$, compId);
export const setRootFolder$ = (FolderInfo: any, compId: string) =>
  setObservableById(rootFolderSubject$, FolderInfo, compId);
